module.exports = __webpack_public_path__ + "static/media/p200-tip-box-open.72b62395.svg";